import React from "react";
import { Icon } from "semantic-ui-react";
import "./contentCard.css";
import docIcon from "../../assets/images/doc_type/DOC.svg";
import audIcon from "../../assets/images/doc_type/AUD.svg";
import webIcon from "../../assets/images/doc_type/WEB.png";
import logoImage from "../../assets/images/logo.png";

const PlayIcon = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polygon points="200,160 360,256 200,352" fill="#191A1D" />
  </svg>
);

const ContentCard = ({ content }) => {
  return (
    <div
      className="content-card"
      title={content.contentName}
      onClick={() => window.open(content.contentFilePath, "_blank")}
    >
      {content.contentType === "IMG" ? (
        <img
          className="content_img"
          src={
            content.contentThumbnail
              ? content.contentThumbnail
              : content.contentFilePath
          }
          alt={content.contentName}
        ></img>
      ) : content.contentType === "VID" ? (
        <div
          style={{
            width: "100%",
            position: "relative",
            display: "inline-block",
          }}
        >
          <img
            style={{
              width: "100%",
              opacity: 0.6,
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: 0,
            }}
            className="content_img"
            src={
              content.contentThumbnail ? content.contentThumbnail : logoImage
            }
            alt={content.contentName}
          />
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              pointerEvents: "none", // allow clicks to pass through if needed
            }}
          >
            <Icon name="play" className="type-icon" style={{ fontSize: 50 }} />
          </div>
        </div>
      ) : (
        <div className="content_icon">
          {renderContentIcon(content.contentType)}
        </div>
      )}

      <div className="content_name">
        <div className="content_txt">{content.contentName}</div>
      </div>
    </div>
  );
};

const renderContentIcon = (type) => {
  switch (type) {
    case "DOC":
      return <img src={docIcon} className="type-icon" alt={type} />;
    case "AUD":
      return <img src={audIcon} className="type-icon" alt={type} />;
    case "WEB":
      return <img src={webIcon} className="type-icon" alt={type} />;
    default:
      return <Icon name="file" className="type-icon" />;
  }
};

export default ContentCard;
